module.exports = __webpack_public_path__ + "img/skyline_2AB_1200.3bed25f8.png";